export default function Timeline() {
	return (
		<section
			aria-label="linha do tempo do surgimento do Instituto Deixe Vivo"
			className={`timeline`}
		>
			<ul className="timeline-list">
				<li className="timeline-item">
					<div className="timeline-content">
						<div className="timeline-time" tabIndex={0}>
							<h2 aria-label="Em 2017">
								<time dateTime="2017">2017</time>
							</h2>
						</div>
						<p tabIndex={0}>
							Nasce a ideia do #deixevivo como um perfil nas redes sociais,
							criado pela Giovanna Fiori, idealizadora do projeto, onde
							compartilhava sua trajetória enquanto paciente renal em
							hemodiálise e de como o transplante, por meio da doação de órgãos,
							transformou sua vida.
						</p>
					</div>
				</li>
				<li className="timeline-item">
					<div className="timeline-content">
						<div className="timeline-time" tabIndex={0}>
							<h2 aria-label="Em 2021">
								<time dateTime="2021">2021</time>
							</h2>
						</div>
						<p tabIndex={0}>
							De <time dateTime="2018">2018</time> a{' '}
							<time dateTime="2020">2020</time>, o projeto #deixevivo continuou
							crescendo - ainda no mundo virtual -, como uma forma de inspirar,
							informar e partilhar histórias sobre doação de órgãos. Em 2021,
							expandiu, tornando-se um coletivo de pessoas nomeado como REDE
							#deixevivo - o que foi uma excelente oportunidade para que mais
							pessoas pensassem sobre a causa, buscando formas de dar
							visibilidade para a doação de órgãos e tecidos, bem como para
							todas as partes envolvidas nesse tema.
						</p>
					</div>
				</li>
				<li className="timeline-item">
					<div className="timeline-content">
						<div className="timeline-time" tabIndex={0}>
							<h2 aria-label="Em 2022"><time dateTime='2022'>2022</time></h2>
						</div>
						<p tabIndex={0}>
							A ascensão da REDE #deixevivo, nos direcionou à ideia de fundar
							uma OSC (Organização da Sociedade Civil), com a missão de
							despertar a cultura da doação de órgãos e tecidos na sociedade por
							meio de informação, inspiração e acolhimento.
						</p>
						<br />
						<ul tabIndex={0}>
							<li>
								• Informar toda a sociedade sobre a doação de órgãos e tecidos e
								outros temas relacionados (como cuidado e prevenção da saúde
								renal);
							</li>
							<li>
								• Inspirar cada vez mais pessoas a se declararem doadoras de
								órgãos e tecidos para suas famílias e mostrar que a doação salva
								vidas e permite que muitos sonhos sejam realizados;
							</li>
							<li>
								• Acolher pacientes renais crônicos, transplantados e seus
								familiares por meio da Rede de Acolhimento.
							</li>
						</ul>
					</div>
				</li>
				<li className="timeline-item">
					<div className="timeline-content">
						<div className="timeline-time">
							<h2 aria-label="Em 2023" tabIndex={0}>
								<time dateTime='2023'>2023</time>
							</h2>
						</div>
						<p tabIndex={0}>
							Em <time dateTime='04-2023'>abril deste ano</time>, completamos 1 ano como OSC, com uma equipe de
							gestão e voluntariado que se dedica dia após dia para que possamos
							cumprir a nossa missão. Hoje, já são mais de 10.000 pessoas
							impactadas pelos conteúdos, ações, eventos e campanhas promovidas
							pelo Instituto Deixe Vivo.
						</p>
					</div>
				</li>
			</ul>
		</section>
	);
}
